import React from 'react';
import { useAuth } from '../auth/AuthContext';
import { Navigate } from 'react-router-dom';

const LoginPage = () => {
  const { authenticated, login, register } = useAuth();

  if (authenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <main className="mp-access">
      <section className="mp-access-card">
        <img src="/magisprev-icon.png" width="56" height="56" alt="" />
        <p className="eyebrow">Dashboard</p>
        <h1>MagisPrev</h1>
        <p>Motor de cálculos previdenciários.</p>

        <div className="d-grid gap-2">
          <button className="btn btn-primary btn-lg" onClick={login}>
            Entrar
          </button>
          <button className="btn btn-outline-secondary" onClick={register}>
            Criar conta
          </button>
        </div>

        <p className="mp-access-note text-muted">
          O acesso requer autorização prévia de um administrador.
        </p>
      </section>
    </main>
  );
};

export default LoginPage;
